export default "__VITE_ASSET__CQJtGM8o__"